import AnnualReportForm from "../../../model/AnnualReportForm";

const AFFILIATES_QUESTION_TEXT = `Please provide the names of any Affiliates1 institutes who have access to UK Biobank 
      data for this Research Project.`;
const AFFILIATES_QUESTION_AFFILIATE_MEANING = `* An Affiliate means any company or other entity that is directly or 
      indirectly Controlling, Controlled by, or under common Control with a Collaborator (which includes if such 
      Collaborator is a company, a subsidiary or parent or holding company of such Collaborator, or a subsidiary of such 
      parent or holding company) for so long as such Control exists. Please see the definition of ‘Control’ in the MTA 
      for further information.`

/**
 * Props for this component
 */
interface AffiliatesQuestionProps {
   form: AnnualReportForm,
   isLocked: boolean,
}

/**
 * Common Annual Report question regarding the affiliates in the institution that have access to the data.
 *
 * Used in: {@link CollaboratorAnnualReportForm|Collaborator annual report},
 *          {@link ApplicantAnnualReportForm|Applicant annual report}
 *
 * @param form An {@link AnnualReportForm} object with a saved report (Could be empty if it's a new report)
 * @param isLocked A boolean to indicate if the report is locked for editing or not
 */
export default function affiliatesQuestion({form, isLocked}: AffiliatesQuestionProps) {
   return (
      <div id="affiliateQ" className="annual-report-question">
         <label id="affiliateQMainText" className="question-text">{AFFILIATES_QUESTION_TEXT}</label>
         <span id="affiliateQExtraInfo" className="extra-info">{AFFILIATES_QUESTION_AFFILIATE_MEANING}</span>
         <textarea id="affiliateQInput" name="affiliateQInput" className="form-control" rows={3}
                   placeholder="Affiliates" disabled={isLocked}
                   onChange={(e) => form.affiliates = encodeURIComponent(e.target.value)}
                   required minLength={100} maxLength={2000}>
            {decodeURIComponent(form.affiliates ? form.affiliates : '')}</textarea>
         <div id="lastYearResScopeFeedback" className="invalid-feedback">
            Your answer must have between 100 and 1000 characters.
         </div>
      </div>
   );
}
